import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Section from '../_Misc/Section';
import { CardHolder, Container } from './style';
import { integrationBroadcast } from '../../../../App';
import {
  fetchUser,
  integrateCalendarResponse,
  integrateZoomResponse,
  integrateSlackResponse,
  integrateSalesforceResponse,
  integrateHubspotResponse,
} from '../../../../redux/slices/sessionSlice';
// import { SlackIntegrationCard } from './SlackIntegrationCard';
import { GoogleIntegrationCard } from './GoogleCalendarIntegrationCard';
import { ZoomIntegrationCard } from './ZoomIntegrationCard';
import { MicrosoftCalendarIntegrationCard } from './MicrosoftCalendarIntegrationCard';
import { Tabs } from 'antd';
import { ZapierIntegrationCard } from './ZapierIntegrationCard';
import { SlackIntegrationCard } from './SlackIntegrationCard';
import { GongIntegrationCard } from './GongIntegrationCard';
import { ClariIntegrationCard } from './ClariIntegrationCard';
import { CrmIntegrationCard } from './CrmIntegrationCard';

interface Props {
  name?: string;
}

const Integrations: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState('all');
  const tabs = [
    { key: 'all', label: `View All` },
    { key: 'workspace', label: `Workspace Integrations` },
    { key: 'user', label: `User Integrations` },
  ];

  const cards = [
    { key: 'zoom', tabs: ['all', 'user'], node: <ZoomIntegrationCard /> },
    { key: 'google', tabs: ['all', 'user'], node: <GoogleIntegrationCard /> },
    { key: 'microsoft', tabs: ['all', 'user'], node: <MicrosoftCalendarIntegrationCard /> },
    { key: 'slack', tabs: ['all', 'workspace'], node: <SlackIntegrationCard /> },
    { key: 'zapier', tabs: ['all', 'workspace'], node: <ZapierIntegrationCard /> },
    { key: 'gong', tabs: ['all', 'workspace'], node: <GongIntegrationCard /> },
    { key: 'clari', tabs: ['all', 'workspace'], node: <ClariIntegrationCard /> },
    { key: 'crm', tabs: ['all', 'workspace'], node: <CrmIntegrationCard /> },
  ];

  integrationBroadcast.onmessage = event => {
    dispatch(fetchUser());

    if (event.data.source && event.data.source === 'NYLAS') {
      dispatch(integrateCalendarResponse(event.data.errorMessage));
    }

    if (event.data.source && event.data.source === 'ZOOM') {
      dispatch(integrateZoomResponse(event.data.errorMessage));
    }

    if (event.data.source && event.data.source === 'SLACK') {
      dispatch(integrateSlackResponse(event.data.errorMessage));
    }

    if (event.data.source && event.data.source === 'SALESFORCE') {
      dispatch(integrateSalesforceResponse(event.data.errorMessage));
    }

    if (event.data.source && event.data.source === 'HUBSPOT') {
      dispatch(integrateHubspotResponse(event.data.errorMessage));
    }
  };

  return (
    <Container>
      <Section
        title="Integrations and connected apps"
        description="Connect, tweak and turbocharge your workflow with third-party applications here!"
      />

      <Tabs
        items={tabs}
        style={{
          width: '100%',
          marginTop: '15px',
          marginBottom: '15px',
          color: '#566976',
        }}
        activeKey={selectedTab}
        onChange={(tab: string) => setSelectedTab(tab)}
      />

      <CardHolder>{cards.filter(c => c.tabs.includes(selectedTab)).map(c => c.node)}</CardHolder>
    </Container>
  );
};

export default Integrations;
